import { RefreshCw } from "lucide-react";

import { Button } from "../../shared/ui/button";
import { Spinner } from "../../shared/ui/spinner";

export function AppLoadingScreen() {
  return (
    <div className="flex min-h-[100svh] items-center justify-center gap-2 text-sm font-bold text-foreground-muted">
      <Spinner />
      <span>Loading the field…</span>
    </div>
  );
}

export function AppConnectionErrorScreen({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="flex min-h-[100svh] flex-col items-center justify-center gap-3 px-4 text-center">
      <div>
        <h1 className="m-0 font-mono text-lg text-warning">Connection lost</h1>
        <p className="mt-1 mb-0 text-sm text-foreground-muted">
          Lost connection to the dugout.
        </p>
      </div>
      <Button type="button" onClick={onRetry} variant="outline">
        <RefreshCw className="size-4" />
        RETRY
      </Button>
    </div>
  );
}
